export default __webpack_public_path__ + "static/media/duplicate-new.8830b961.svg";